import { Box, Button } from '@mui/material';
import { useAtom } from 'jotai';
import { ShiftType } from '@/__generated__/graphql';
import * as kpiState from '../../state';
import { shiftSelectorContainerStyles, getShiftButtonStyles } from './styles';

export const KpiShiftSelector = () => {
  const [selectedShift, setSelectedShift] = useAtom(kpiState.selectedShift);

  const handleShiftChange = (shift: ShiftType) => {
    setSelectedShift(shift);
  };

  return (
    <Box sx={shiftSelectorContainerStyles}>
      <Button
        onClick={() => handleShiftChange(ShiftType.Day)}
        sx={getShiftButtonStyles(selectedShift === ShiftType.Day)}
      >
        Day
      </Button>
      <Button
        onClick={() => handleShiftChange(ShiftType.Night)}
        sx={getShiftButtonStyles(selectedShift === ShiftType.Night)}
      >
        Night
      </Button>
    </Box>
  );
};
